import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { ApiService } from '../../../../src/app/shared/services/api.service';

@Injectable()
export class PitchApiService implements ApiService {
  constructor(private http: HttpClient) {}

  get<T>(path: string, params): Observable<T>;

  get(path: string, params): Observable<any> {
    return this.http.get(this.getUrl(path), params);
  }

  post<T>(path: string, param: any, headers: any): Observable<T>;
  post(path: string, params = {}, headers = {}): Observable<any> {
    return this.http.post(this.getUrl(path), params, headers);
  }

  postFormData<T>(path: string, data: FormData, queryParams?: any, headers?: any): Observable<T>;
  postFormData(path: string, data: FormData, queryParams = {}, headers = {}): Observable<any> {
    const httpHeaders = new HttpHeaders({ ...headers });

    return this.http.post(this.getUrl(path), data, {
      headers: httpHeaders,
      params: queryParams
    });
  }

  private getUrl(path: string) {
    const { apiUrl } = environment;
    return `${apiUrl}${path}`;
  }

  put(path: string, params = {}, headers = {}): Observable<any> {
    return this.http.put(this.getUrl(path), params, headers);
  }

  delete(path: string, params = {}): Observable<any> {
    return this.http.delete(this.getUrl(path), params);
  }

  // postFormData(): Observable<any> {
  //   throw new Error('Method not implemented.');
  // }
}
